import { useCsAttribute } from "../useCsAttribute";
/**
 * Displays the name of the current attribute.
 * @category Hook
 * @returns
 */
export function useConfigurationAttributeName() {
    var _a;
    const attribute = useCsAttribute();
    return (_a = attribute.name) !== null && _a !== void 0 ? _a : attribute.id;
}
//# sourceMappingURL=useConfigurationAttributeName.js.map